import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { RootState } from '../../../store/store';

export type ScopeType = 'organization' | 'team';

interface SelectedScope {
  type: ScopeType;
  teamId?: number;
}

interface CultureHubRootState {
  selectedScope: SelectedScope;
  selectedAssessmentPeriodId: number | null;
  isSaving: boolean;
}

const initialState: CultureHubRootState = {
  selectedScope: {
    type: 'organization',
  },
  selectedAssessmentPeriodId: null,
  isSaving: false,
};

const cultureHubRootSlice = createSlice({
  name: 'cultureHubRoot',
  initialState,
  reducers: {
    setSelectedScope(state, action: PayloadAction<SelectedScope>) {
      state.selectedScope = action.payload;
    },
    setSelectedAssessmentPeriodId(state, action: PayloadAction<number | null>) {
      state.selectedAssessmentPeriodId = action.payload;
    },
    setSaving(state, action: PayloadAction<boolean>) {
      state.isSaving = action.payload;
    },
    resetCultureHubRoot() {
      return initialState;
    },
  },
});

export const {
  setSelectedScope,
  setSelectedAssessmentPeriodId,
  setSaving,
  resetCultureHubRoot,
} = cultureHubRootSlice.actions;

// Base selector
const selectRootState = (state: RootState) => state.cultureHubRoot;

// Memoized selectors with reselect
export const getSelectedScope = createSelector(
  [selectRootState],
  (state): SelectedScope => state.selectedScope
);

export const getSelectedAssessmentPeriodId = createSelector(
  [selectRootState],
  (state): number | null => state.selectedAssessmentPeriodId
);

export const getIsSaving = createSelector(
  [selectRootState],
  (state): boolean => state.isSaving
);

export default cultureHubRootSlice;
